import * as ROUTES from 'constant/routes'
import { Redirect, Route, Switch, withRouter } from 'react-router-dom'
import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import PropTypes from 'prop-types'
import * as Components from './lazy-components'

const LoggedOutRoutes = ({ location }) => {
  return (
    <Container fluid>
      <Row>
        <Col>
          <Switch>
            <Route
              component={Components.Login}
              path={ROUTES.LOGIN}
            />
            <Redirect
              to={{ pathname: ROUTES.LOGIN, state: { from: location } }}
            />
          </Switch>
        </Col>
      </Row>
    </Container>
  )
}

LoggedOutRoutes.propTypes = {
  location: PropTypes.object
}

export default withRouter(LoggedOutRoutes)
